import type { RolePermissions } from '@tco/shared-types'

/**
 * Check if permissions grant access to a resource.
 * Supports formats: {"all": true} for admin, {"employees": ["read", "write"]} for custom roles
 */
export function hasPermission(permissions: RolePermissions | undefined, resource: string, action?: string): boolean {
  if (!permissions) return false
  if (permissions.all === true) return true
  const resourcePerms = permissions[resource]
  if (!resourcePerms) return false
  if (!action) return true
  if (Array.isArray(resourcePerms)) return resourcePerms.includes(action)
  return false
}

export function isAdmin(permissions: RolePermissions | undefined): boolean {
  return permissions?.all === true
}

/** All permission resources used in the admin panel */
export const PERMISSION_RESOURCES = [
  'employees',
  'departments',
  'positions',
  'locations',
  'schedules',
  'staffing_limits',
  'attendance',
  'time_records',
  'reports',
  'notifications',
  'organizations',
  'testing',
  'my_tests',
  'documents',
  'feedback',
  'users',
  'activity_logs',
  'settings',
  'gamification',
  'schedule_requests',
  'smart_schedule',
  'news',
  'checklists',
] as const

export type PermissionResource = typeof PERMISSION_RESOURCES[number]

export const PERMISSION_ACTIONS = ['read', 'write'] as const
export type PermissionAction = typeof PERMISSION_ACTIONS[number]

/** Human-readable labels for resources */
export const RESOURCE_LABELS: Record<PermissionResource, string> = {
  employees: 'Сотрудники',
  departments: 'Отделы',
  positions: 'Должности',
  locations: 'Локации',
  schedules: 'Расписания',
  staffing_limits: 'Лимиты смен',
  attendance: 'Посещаемость',
  time_records: 'Учет времени',
  reports: 'Отчеты',
  notifications: 'Уведомления',
  organizations: 'Организации',
  testing: 'Тестирование',
  my_tests: 'Мои тесты',
  documents: 'Документы',
  feedback: 'Обратная связь',
  users: 'Пользователи',
  activity_logs: 'Журнал действий',
  settings: 'Настройки',
  gamification: 'Геймификация',
  schedule_requests: 'Заявки на графики',
  smart_schedule: 'Smart Schedule',
  news: 'Новости',
  checklists: 'Чек-листы',
}

export const ACTION_LABELS: Record<PermissionAction, string> = {
  read: 'Просмотр',
  write: 'Редактирование',
}
